export default "__VITE_ASSET__BXN5HH95__"